<template lang="html">
  <vue100vh style="position: fixed;width: 100%;">
  <v-layout row wrap align-center justify-center v-if="progress" class="layout-height">
    <v-progress-circular :size="80" :indeterminate="progress" color="primary"></v-progress-circular>
  </v-layout>
  <div class="layout-height" v-else>
    <v-layout column wrap v-if="statefriend !== 'group'">
      <v-toolbar class="bg-toolbar">
        <v-btn color="black" flat icon dark @click="toPage()">
          <v-icon>chevron_left</v-icon>
        </v-btn>
        <v-toolbar-title class="ml-0">{{$t('Settings.editProfile.profile')}}</v-toolbar-title>
      </v-toolbar>
      <img :src="inforfriend.profilepicture" class="img-w-h" v-if="inforfriend.profilepicture" @click="detailimageFriend(inforfriend)">
      <img src="/static/img/default_profile/bot-white.png" class="img-w-h" v-else-if="inforfriend.type == 'bot'" @click="detailimageFriend(inforfriend)">
      <img src="/static/img/default_profile/business-white.png" class="img-w-h" v-else-if="inforfriend.type == 'business'" @click="detailimageFriend(inforfriend)">
      <img src="/static/img/default_profile/man-white.png" class="img-w-h" v-else @click="detailimageFriend(inforfriend)">
      <v-layout row wrap justify-center align-center class="width-100">
        <v-btn class="btn-action text-transform" @click="actionclick(inforfriend)">{{ btntext }}</v-btn>
      </v-layout>
      <v-system-bar class="width-100">{{$t('Settings.editProfile.displayName')}}</v-system-bar>
      <span class="mb-2 mt-2 ml-3 font-16 text-hidden">{{inforfriend.name}}</span>

      <v-system-bar class="width-100">{{$t('Settings.editProfile.status')}}</v-system-bar>
      <span class="mb-2 mt-2 ml-3 font-16 text-hidden" v-if="inforfriend.status != ''">{{inforfriend.status}}</span>
      <span class="mb-2 mt-2 ml-3 font-16 text-hidden" v-else-if="inforfriend.status == ''">-</span>

      <v-system-bar class="width-100" v-if="relation == 'friend'">{{$t('Settings.editProfile.phone')}}</v-system-bar>
      <span class="mb-2 mt-2 ml-3 font-16" v-if="relation == 'friend' && inforfriend.phone != ''">{{inforfriend.phone}}</span>
      <!-- <span class="mb-2 mt-2 ml-3 font-16" v-else-if="relation != 'friend' && inforfriend.phone == ''">-</span> -->
      <span class="mb-2 mt-2 ml-3 font-16" v-else-if="relation == 'friend' && inforfriend.phone == ''">-</span>

      <v-system-bar class="width-100">{{$t('Settings.editProfile.email')}}</v-system-bar>
      <span class="mb-2 mt-2 ml-3 font-16" v-if="inforfriend.email">{{inforfriend.email}}</span>
      <span class="mb-2 mt-2 ml-3 font-16" v-else>-</span>
    </v-layout>
    <v-layout column wrap v-else>
      <v-toolbar class="bg-toolbar">
        <v-btn color="black" flat icon dark @click="toPageQrcode()">
          <v-icon>chevron_left</v-icon>
        </v-btn>
        <v-toolbar-title class="ml-0">{{$t('Settings.editProfile.group')}}</v-toolbar-title>
      </v-toolbar>
      <img :src="inforfriend.picture" class="img-w-h" v-if="inforfriend.picture" @click="detailimageFriend(inforfriend)">
      <img src="/static/img/default_profile/group-white.png" class="img-w-h" v-else @click="detailimageFriend(inforfriend)">
      <v-layout row wrap justify-center align-center class="width-100" v-if="relation == 'group' || relation == 'active'">
        <v-flex xs12 sm12>
          <v-btn class="btn-action text-transform" @click="actionclick(inforfriend)">{{ btntext }}</v-btn>
        </v-flex>
        <!-- <v-flex xs6 sm6>
          <v-btn class="btn-action-profile" @click="actionclick(inforfriend)">ดูข้อมูลเพิ่ม</v-btn>
        </v-flex> -->
      </v-layout>
      <v-layout row wrap justify-center align-center class="width-100" v-else>
        <v-flex xs6 sm6>
          <v-btn class="btn-action text-transform" @click="acceptgroupclick(inforfriend)">{{ btntext }}</v-btn>
        </v-flex>
        <v-flex xs6 sm6>
          <v-btn class="btn-action-profile text-transform" @click="canclegroupclick(inforfriend)">{{$t('AnswerQuestion.cancel')}}</v-btn>
        </v-flex>
      </v-layout>
      <v-system-bar class="width-100">{{$t('Settings.editProfile.groupName')}}</v-system-bar>
      <span class="mb-2 mt-2 ml-3 font-16 text-hidden">{{inforfriend.name}}</span>

      <v-system-bar class="width-100">{{$t('RightSide.member')}}</v-system-bar>
      <v-list v-if="inforfriend.member.length !== 0">
          <v-list-tile
            v-for="item in inforfriend.member"
            :key="item.tokenuser"
            v-if="item.statemember == 'active'"
          >
          <v-list-tile-avatar v-if="item.statemember == 'active'">
            <v-img :src="item.profile"></v-img>
          </v-list-tile-avatar>
          <v-list-tile-content v-if="item.statemember == 'active'">
            <v-list-tile-title>
                <p class="text-title mb-0 ml-3">{{item.name}}</p>
            </v-list-tile-title>
          </v-list-tile-content>
            <!-- <v-divider></v-divider> -->
          </v-list-tile>
        </v-list>
      <h4 v-else>{{$t('RightSide.noMember')}}</h4>
    </v-layout>
  </div>
</vue100vh>
</template>

<script>
import { Decode } from '@/services'
import { sync } from 'vuex-pathify'
import vue100vh from 'vue-100vh'
var _ = require('lodash')
export default {
  props: {
  },
  data () {
    return {
      token: '',
      tokenfriend: '',
      inforfriend: {},
      relation: '',
      btntext: '',
      progress: false,
      typefriend: '',
      statefriend: ''
    }
  },
  computed: {
    ...sync('*')
  },
  components: {
    vue100vh
  },
  watch: {
    socketremove_request_friend (data) {
      // console.log(data)
      this.relation = 'unknown'
      this.btntext = this.$t('AnswerQuestion.addFiend')
    },
    socketaccept_friend (data) {
      // console.log(data)
      this.relation = 'friend'
      this.btntext = this.$t('AnswerQuestion.chat')
    },
    socketfriend (data) {
      // console.log(data)
      if (data.konAdd != this.token) {
        this.relation = 'request'
        this.btntext = this.$t('AnswerQuestion.acceptFriend')
      } else {
        this.relation = 'sendrequest'
        this.btntext = this.$t('AnswerQuestion.cancelRequest')
      }
    },
    socketremove_friend (data) {
      // console.log(data)
      this.relation = 'unfriend'
      this.btntext = this.$t('AnswerQuestion.addFiend')
    },
    socketblock (data) {
      // console.log(data)
    }
  },
  created () {
    this.typefriend = localStorage.getItem('typefriend')
    var decoded = JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    this.token = decoded['tokenuser']
    // this.tokenfriend = Decode.decodeToken(localStorage.getItem('tokenfriend'))
    this.searchuser()
  },
  methods: {
    detailimageFriend (detailfriend) {
      // console.log(detailfriend)
      var picture = ''
      if (detailfriend.type !== 'group') {
        picture = detailfriend.profilepicture
        if (picture == '') {
          if (detailfriend.type == 'user') {
            picture = '/static/img/default_profile/man-white.png'
          } else if (detailfriend.type == 'bot') {
            picture = '/static/img/default_profile/bot-white.png'
          } else if (detailfriend.type == 'business') {
            picture = '/static/img/default_profile/business-white.png'
          } else {
            picture = '/static/img/default_profile/man-white.png'
          }
        }
      } else {
        picture = detailfriend.picture
        if (picture == '') {
          picture = '/static/img/default_profile/group-white.png'
        } else {
          picture = detailfriend.picture
        }
      }

      this.$swal({
        imageUrl: picture,
        imageHeight: 250,
        showCloseButton: true,
        showConfirmButton: false,
      })
    },
    toPage () {
      // console.log(this.inforfriend)
      // console.log(this.$router.push(-1))
      this.$router.go(-1)
      // this.$router.push('/mobile/room/' + this.inforfriend.tokenroom)
    },
    toPageQrcode () {
      this.$router.push('/mobile/qrcode')
    },
    searchuser () {
      if (this.typefriend !== 'group') {
        this.progress = true
        this.statefriend = 'friend'
        this.axios.post(process.env.APImanage + '/searchtokenuser', {tokenuser: this.token, tokenfriend: this.$route.params.profileid}).then((response) => {
          // console.log(response.data)
          if (response.data.status === 'success') {
            this.progress = false
            this.relation = response.data.relation
            this.inforfriend = response.data.user
            if (this.relation == 'friend') {
              this.btntext = this.$t('AnswerQuestion.chat')
            } else if (this.relation == 'request') {
              this.btntext = this.$t('AnswerQuestion.acceptFriend')
            } else if (this.relation == 'request') {
              this.btntext = this.$t('AnswerQuestion.acceptFriend')
            } else if (this.relation == 'sendrequest') {
              this.btntext = this.$t('AnswerQuestion.cancelRequest')
            } else if (this.relation == 'unknown') {
              this.btntext = this.$t('AnswerQuestion.addFriend')
            } else if (this.relation == 'self') {
              this.btntext = this.$t('AnswerQuestion.ok')
            } else if (this.relation == 'unfriend') {
              this.btntext = this.$t('AnswerQuestion.addFiend')
            } else if (this.relation == 'block') {
              this.btntext = this.$t('AnswerQuestion.unblock')
            }
          }
        })
      } else {
        this.progress = true
        this.statefriend = 'group'
        this.axios.post(process.env.APImanage + '/getgroup', {tokenuser: this.token, group_id: this.$route.params.profileid}).then((response) => {
          // console.log(response.data)
          if (response.data.status === 'success') {
            this.progress = false
            this.relation = response.data.group.state
            this.inforfriend = response.data.group
            if (this.relation == 'group' || this.relation == 'active') {
              this.btntext = this.$t('AnswerQuestion.chat')
            } else {
              this.btntext = this.$t('AnswerQuestion.joinGroup')
            }
          }
        })
      }
    },
    actionclick (inforfriend) {
      // console.log(inforfriend)
      // console.log(this.relation)
      if (this.relation == 'friend') {
        this.$router.push('/mobile/room/' + inforfriend.tokenroom)
      } else if (this.relation == 'unknown' || this.relation == 'unfriend') {
        this.addfriend(inforfriend.tokenuser)
      } else if (this.relation == 'sendrequest') {
        this.remove_send_request(inforfriend.tokenuser)
      } else if (this.relation == 'request') {
        this.acceptfriend(inforfriend.tokenuser)
      } else if (this.relation == 'block') {
        this.unblock(inforfriend.tokenuser, inforfriend.name, inforfriend.tokenroom)
      } else if (this.relation == 'group' || this.relation == 'active') {
        // console.log(this.relation)
        this.$router.push('/mobile/room/' + inforfriend.tokenroom)
        // console.log(inforfriend)
      } else if (this.relation == 'leave') {
        // console.log(this.relation)
        this.acceptgroupclick(inforfriend)
        // console.log(inforfriend)
      } else if (this.relation == 'self') {
        this.$router.go(-1)
      }
    },
    acceptgroupclick (inforfriend) {
      // console.log(inforfriend)
      this.axios.post(process.env.APImanage + '/joingroup', {group_id: inforfriend.group_id, tokenuser: this.token}).then((response) => {
        // console.log(response.data)
        if (response.data.status === 'success') {
          this.relation = response.data.group.state
          this.btntext = this.$t('AnswerQuestion.chat')
          this.$swal('', this.$t('Alert.Success.success'), 'success')
          var tokenuser = this.token
          var indexgroup = _.findIndex(response.data.group.member, function (o) { return o.tokenuser === tokenuser })
          if (indexgroup >= 0) {
            this.socketactive_group = {timestamp: response.data.group.member[indexgroup].timestamp_in, groupid: inforfriend.group_id, tokenuser: this.token}
          } else {
            this.socketactive_group = {timestamp: '', groupid: inforfriend.group_id, tokenuser: this.token}
          }
          this.$router.push('/mobile/room/' + response.data.group.tokenroom)
        }
      })
    },
    canclegroupclick (inforfriend) {
      // console.log(inforfriend)
      this.$swal({
        // text: 'คุณต้องการยกเลิกเข้าร่วมกลุ่ม ' + inforfriend.name +' ใช่หรือไม่?',
        text: this.$t('Alert.Group.cancelGroup', { name: inforfriend.name }),
        type: 'warning',
        imageHeight: 70,
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.axios.post(process.env.APImanage + '/cancelinvitegroup', {group_id: inforfriend.group_id, tokenuser: this.token}).then((response) => {
            if (response.data.status === 'success') {
              this.$swal('', this.$t('Alert.Success.success'), 'success')
              this.$router.push('/mobile/qrcode')
            } else {
              this.$swal('', this.$t('Alert.Fail.default.somethingWrong'), 'warnning')
            }
          })
        }
      })
    },
    addfriend (tokenuser) {
      // this.axios.post(process.env.APInew_addfriend, {tokenfriend: tokenuser, tokenuser: this.token}).then((response) => {
      //   if (response.data['status'] === 'success') {
      //   }
      // })
      this.axios.post(process.env.APIgo_api + `/v1/add-friend-accept`, {tokenfriend: tokenuser, tokenuser: this.token}).then((response) => {
        if (response.data.status === 'success') {
          // console.log(response.data)
          this.relation = 'friend'
          this.btntext = this.$t('AnswerQuestion.chat')
          this.inforfriend.tokenroom = response.data.tokenroom
        } else {
          // this.$swal('', 'ไม่สามารถแชทได้ กรุณาลองใหม่ภายหลัง', 'warning')
          this.$swal('', this.$t('Alert.Fail.default.somethingWrong'), 'warnning')
        }
      }).catch(error => {
        console.log(error)
        // this.$swal('', 'ไม่สามารถแชทได้ กรุณาลองใหม่ภายหลัง', 'warning')
        this.$swal('', this.$t('Alert.Fail.default.somethingWrong'), 'warnning')
      })
    },
    remove_send_request (tokenuser) {
      this.axios.post(process.env.APImanage + '/removerequestfriend', {tokenfriend: tokenuser, tokenuser: this.token}).then((response) => {
        if (response.data['status'] === 'success') {
          this.relation = 'unknown'
          this.btntext = this.$t('AnswerQuestion.addFriend')
        }
      })
    },
    acceptfriend (tokenuser) {
      this.axios.post(process.env.APInew_acceptfriend, {tokenfriend: tokenuser, tokenuser: this.token}).then((response) => {
        if (response.data['status'] === 'success') {
          // console.log(response.data)
        }
      })
    },
    unblock (tokenuser, name, tokenroom) {
      this.$swal({
        // text: 'คุณต้องการยกเลิกการบล็อก ' + name + ' ใช่หรือไม่?',
        text: this.$t('Alert.Unblocking', { name: name }),
        type: 'warning',
        imageHeight: 70,
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.axios.post(process.env.APImanage + '/unblockfriend', { tokenfriend: tokenuser, tokenuser: this.token, tokenroom: tokenroom }).then((response) => {
            if (response.data['status'] === 'success') {
              // console.log(response.data)
              this.$swal(
                '',
                this.$t('Alert.Success.unblock'),
                'success'
              )
              this.relation = 'friend'
              this.btntext = this.$t('AnswerQuestion.chat')
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="css" scoped>
.text-transform {
  text-transform: none;
}
.text-hidden {
  white-space: nowrap;
  width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.text-title {
  white-space: nowrap;
  width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.layout-height {
  height: calc(100vh - 64px) !important;
  overflow-x: hidden !important;
  overflow-y: scroll !important;
}
.img-w-h {
  object-fit: cover;
  object-position: 50% 40%;
  height: 150px;
  width: 100%;
}
.bg-toolbar {
  background-color: white;
}
.width-100 {
  width: 100%;
}
.btn-action {
  width: 95% !important;
  background-color: #2562af !important;
  color: white !important;
  border-radius: 20px !important;
  font-size: 18px !important;
}
.btn-action-profile {
  width: 95% !important;
  background-color: #ffffff !important;
  color: #2562af !important;
  border-radius: 20px !important;
  font-size: 18px !important;
  border-color: #2562af !important;
  border-style: solid !important;
  border-width: thin !important;
}
.font-16 {
  font-size: 16px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/manage/Profilefriend.vue